// 缓存到本地的答案列表
export const LOCAL_QUES_ANSWERS = 'LOCAL_QUES_ANSWERS'

// 缓存本地的答案列表的uuid
export const LOCAL_QUES_ANSWERS_UUID = 'LOCAL_QUES_ANSWERS_UUID'

// 国学小名仕特定一套
export const GXXMS_QUES_KEY = 'c47cdc4800f5449b8b201af9c117489e'

// 闪电定制
export const SD_QUES_KEY_2024_12_5 = 'c333e9a328124531b93e6d0637b3ae4c'
